
import { Options, Vue } from "vue-class-component";
import AppButton from "@/components/common/AppButton.vue";
import AppInput from "@/components/common/form/AppInput.vue";
import JsonTreeView from "@/components/common/JsonTreeView.vue";
import { generateXdr } from "@/services/turret/turret";

@Options({
  components: { JsonTreeView, AppInput, AppButton },
  emits: ["createXdrToken"],
  props: {
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
})
export default class XdrTokenForm extends Vue {
  private newFunctionHash = "";
  private newFunctionHashError = "";
  private functionHashes: string[] = [];
  private xdrToken = "";
  private ttl = "86400";
  private ttlError = "";
  private isSingleUse = "false";
  private requestError = null as unknown;
  private isCreatingXdr = false;

  saveFunctionHash(): void {
    const ttl = Number(this.ttl);
    if (isNaN(ttl)) {
      this.ttlError = "TTL must be a number, in seconds.";
      return;
    }
    if (this.newFunctionHash.length !== 64) {
      this.newFunctionHashError =
        "Function hashes should be 64 characters long";
      return;
    }
    this.functionHashes.push(this.newFunctionHash);
    this.newFunctionHash = "";
    this.newFunctionHashError = "";
  }

  deleteFunctionHash(hash: string): void {
    this.functionHashes.splice(
      this.functionHashes.findIndex((h) => h === hash),
      1
    );
  }

  async createXdrToken(): Promise<void> {
    this.isCreatingXdr = true;
    this.xdrToken = "";
    this.requestError = null;

    try {
      const token = await generateXdr(
        this.$store.state.turret,
        this.$store.getters.keypair,
        this.isSingleUse,
        Number(this.ttl),
        this.functionHashes
      );

      this.xdrToken = token;

      this.$emit("createXdrToken", token);
    } catch (e) {
      this.requestError = e;
    } finally {
      this.isCreatingXdr = false;
    }
  }
}
